/**
* Created by ferto
* Marciano Digital Agency
* www.marciano.com.mx
* Date: 01/02/2018.
*
* app-container Component
*/
<template>
  <div id="app-main">
    <main-loader/>
    <div class="left-container">
      <div class="logo">
        <img
          src="~@/assets/logo.svg"
          alt="Plataforma Five Star"
        >
      </div>
      <scrollable-container>
        <main-menu :items="menuItems"/>
      </scrollable-container>
    </div>
    <div class="right-container">
      <main-top-bar />
      <router-view/>
    </div>
  </div>
</template>

////////////////////////////////////////////
//                                  SCRIPT
////////////////////////////////////////////
<script>
import MainMenu from '@/modules/main-layout/main-menu'
import MainTopBar from '@/modules/main-layout/main-top-bar'
import MainLoader from '@/modules/main-layout/main-loader'
import ScrollableContainer from '@/components/scrollable-container'
import store from '@/store'
import { mapGetters } from 'vuex'

export default {
  name: 'AppContainer',
  components: { MainMenu, MainTopBar, MainLoader, ScrollableContainer },
  data () {
    return {}
  },
  computed: {
    ...mapGetters('menu', {
      menuItems: 'items'
    })
  },
  beforeRouteEnter (to, from, next) {
    let promises = []
    promises.push(store.dispatch('profile/me'))
    promises.push(store.dispatch('profile/permissions'))
    Promise.all(promises)
      .then(next)
      .catch(next)
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style
  lang="scss"
  scoped
>
#app-main {
  background-color: #f3f3f3;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  width: 100vw;
  max-width: 100vw;
  height: 100vh;
  display: flex;
  .left-container {
    max-width: 210px;
    min-width: 160px;
    flex: 0 0 auto;
    background-color: #fff;
    height: 100vh;
    border-right: 1px solid #dddddd;
    .logo {
      margin: 20px;
      img {
        display: block;
        margin: 0 auto;
        width: 100%;
        min-width: 40px;
        max-width: 100px;
      }
    }
  }
  .right-container {
    flex: 1 1 auto;
    overflow: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/app/app-container.vue